module.exports = __webpack_public_path__ + "img/EarHearing-Icon.2aafda2d.png";